module.exports = "### State\n\nWe use these colors to communicate the state of elements like buttons, form fields and images.\n"